import React from 'react';
import CustBanner from "../components/CustBanner";
import CustCategories from "../components/CustCategories";
// eslint-disable-next-line
import Featured from "../components/Featured";
import Contact from "../components/Contact";
import '../assets/Home.css';

function Customizations({items}) {      

  return (
    <div id="customizationsPage">
      <CustBanner />
      <CustCategories items={items} />
      {/* <Featured items={items} /> */}
      <Contact name="META Solutions"/>
    </div>
  );
}

export default Customizations;